import React, { Component } from 'react'
import AccessTime from 'material-ui/svg-icons/device/access-time'
import { GridTile } from 'material-ui/GridList'
import { Link } from 'react-router'
import pdfIcon from '../../../public/images/icons/pdf.svg'
import PinIcon from 'material-ui/svg-icons/action/room'
import RaisedButton from 'material-ui/RaisedButton'
import videoIcon from '../../../public/images/icons/video.svg'
import SocialMediaButtons from './SocialMedia'
import OutreachSlider from './OutreachSlider'

class OutreachCard extends Component {
  constructor(props) {
    super(props)
    this.state={ slideIndex: 0, selectedIndex: -1 }
  }

  render () {
  const { event, detailView, selectedIndex, pathname } = this.props
  const {
    address,
    code,
    description,
    invitationLink,
    key,
    pdf,
    photos,
    shortDate,
    thumbnail,
    timeRange,
    title,
    videos
  } = event
  let documents = [],
    media = []

  photos && photos.src.forEach((photo, index) => {
    const src = photos.src[index]
    const thumbnail = photos.thumbnails[index]
    media.push(
      <div className="carousel-media" key={thumbnail} >
        <img src={src} role="presentation"/>
      </div>
    )
  })

  const videoSize = window.screen.width < 500 ? window.screen.width : 500

  videos && videos.forEach(video => {
    media.push(
      <div className="carousel-media" key={video}>
          <iframe src={video} frameBorder="0" width={videoSize} height={videoSize} allowFullScreen></iframe>
      </div>
    )
  })


  pdf && pdf.forEach((doc, index) => {
    const { url, name } = doc
    documents.push(
      <div key={url}>
        <RaisedButton
          className="download-button"
          href={url}
          key={index}
          label={`${name} PDF`}
          primary={true}
          style={{ maxWidth: '400px', minWidth: '200px', marginTop: '10px', marginBottom: '5px', width: '100%'}}
          target="_blank"
        />
      </div>
    )
  })

  code && documents.push(
    <div key={code}>
      <RaisedButton
        className="download-button"
        href={code}
        label="Workshop Code"
        target="_blank"
        primary={true}
        style={{ maxWidth: '400px', minWidth: '200px', marginTop: '10px', marginBottom: '5px', width: '100%'}}
      />
    </div>
  )

  return (
    <GridTile className="outreach-card" key={title}>
          { detailView  ?
            <div className="outreach-gallery" id="outreach-slider">
              <OutreachSlider selectedIndex={selectedIndex} media={media} />
            </div>
           : 
            <Link className="host-workshop-link" to={`/outreach/${key}`}>
             <div className="card-image">
             <img src={thumbnail} alt=""/>
             </div>
            </Link>
          }
          <div className="card-text">
          <div className="card-text-details">
            <h4>{shortDate}</h4>
          { detailView ? 
            <h5 className="card-detail-title">{title}</h5>
            :
            <Link className="host-workshop-link" to={`/outreach/${key}`}><h5>{title}</h5></Link>
          }
          <div className="outreach-card-subtext">
            <div className="time-range">
              <AccessTime color="white" style={{height: '1em', width: '1em'}}/><span>{timeRange}</span>
            </div>
            { address ? 
              <div className="address">
              <PinIcon color="white"  style={{height: '1em', width: '1em'}}/>
              { address.url ?
                <small>
                  <a href={address.url} target="_blank">{address.title}</a>
                </small>
                :
                <small>{address.title}</small>
              }
          
            </div> : <div className="address"></div>}
          </div>
          <div className="event-description"><p>{description}</p></div>
          {detailView && invitationLink &&
            <div className="invitationLink">
              <a href={invitationLink} target="_blank">RSVP at our Eventbrite Page!</a>
            </div>
          }
          {detailView && pdf &&
            <div className="outreach-pdf-download">
              {documents}
            </div>}
            </div>
          {detailView ? null : <Link className="host-workshop-link" to={`/outreach/${key}`}><p className="view-details">View Details</p></Link>}
          {pathname ? <SocialMediaButtons pathname={pathname} /> : null}
        </div>
        { pdf || videos ?
          <div className="outreach-card-media">
          { pdf && !detailView ? <img src={pdfIcon} alt="pdf" className="icon" /> : null }
          { videos && !detailView ? <img src={videoIcon} alt="video" className="icon" /> : null }
        </div> :
        null }
    </GridTile>
  )
  }
}

export default OutreachCard



// WEBPACK FOOTER //
// ./src/components/Outreach/OutreachCard.js